export const FileType = {
  USER_SIGNATURE: 'USER_SIGNATURE',
  VENDOR_BR: 'VENDOR_BR',
  VENDOR_QUOTATION: 'VENDOR_QUOTATION',
  SOURCING_ANNEX: 'SOURCING_ANNEX',
  SOURCING_FRAME_AGREEMENT: 'SOURCING_FRAME_AGREEMENT',
}
